import { Popover } from "react-bootstrap";
import DateDisplay from "../../../DateDisplay";
import { ThemedIcon } from "../../../utilities";
import ConditionalPopover from "../../../utilities/ConditionalPopover";
import styled from "styled-components";
import ReviewManagementDetailTableStatusIconColumn from "../../../../features/reviewmanagementdetailed/components/ReviewManagementDetailTableStatusIconColumn";

const LargePopover = styled(Popover)`
    max-width: 500px;
`;

const ReviewSectionStatus = ({ isRequired, label, status, statusCommentHeader, statusComment, verifiedDate, verifiedBy, reviewDate, score, targetDate, previousComplete }) => {

    return <>
        {isRequired && <ConditionalPopover
                condition={statusComment != null && statusComment !== "" && typeof(statusComment) !== "undefined"}
                placement="top"
                popover={<LargePopover>
                        <Popover.Body>
                            <div style={{ textAlign: "left" }}>
                                <span>{statusComment}</span>
                            </div>
                        </Popover.Body>
                    </LargePopover>
                }
                >
                <div className="row mb-2">
                    <div className="col-1 d-flex align-items-center justify-content-center">
                        <ReviewManagementDetailTableStatusIconColumn
                            reviewDate={reviewDate}
                            date={verifiedDate}
                            score={score}
                            targetDate={targetDate}
                            previousComplete={true}
                            isColumn={false}
                        />
                    </div>
                    <div className="col-11">
                        <span>{label}: </span>
                        <span>{status} </span>
                        {verifiedDate != null && verifiedBy != null && <>
                                <span> on <DateDisplay format="DD/MM/YYYY">{verifiedDate}</DateDisplay></span>
                                <span> by {verifiedBy}</span>
                        </>}
                    </div>
                </div>
            </ConditionalPopover>}
        </>;
}

export default ReviewSectionStatus;